import { KYMW5500Model } from '../kymw5500.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
/**
 * 画像ファイルリストの取得
 *
 * @export API通信成功時の処理
 * @class GetImageFileList
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageFileListService extends PlessJsonResponderSub<any> {


  // 処理に使用するModel
  private model: KYMW5500Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunction] 成功時後続処理
   * @memberof GetImageFileList
   */
  execute(model: KYMW5500Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getImageFileList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageFileList
   */

  success(data: any) {
    this.model.updateImageFileList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
